import {
  SET_INITIAL_FILTER_INFO,
  SET_CURRENT_FILTER_INFO,
  UPDATE_STOPS_FILTERS_UI,
} from '../../../actions/actionTypes'

/* NUM_OF_STOPS */
export const stopsFilter = (state = [], action) => {
  const { type, payload = {}, meta = {} } = action
  switch (type) {
    case SET_INITIAL_FILTER_INFO:
      return payload.NUM_OF_STOPS || state

    case SET_CURRENT_FILTER_INFO:
      return payload.stopsFilter.map(slice => ({ ...slice }))

    case UPDATE_STOPS_FILTERS_UI:
      const stopKey = Object.keys(payload)[0]
      const { isNoneClick, isAllClick } = meta

      return state.map(stop => {
        if (meta.isOnlyClick) {
          stop.checked = stop.value === stopKey
        } else if (isNoneClick && !stop.disabled) {
          stop.checked = false
        } else if (isAllClick && !stop.disabled) {
          stop.checked = true
        } else {
          // stop.value and stopKey should both be strings
          stop.checked = payload.hasOwnProperty(stop.value)
            ? payload[stop.value]
            : stop.checked
        }

        return stop
      })

    default:
      return state
  }
}
